<template>
    <div class="flex-grid flex-grid--wrap a-form-inputs">
        <form @submit.prevent class="m-form">
            <div class="flex-grid__item">
                <control :name="'dependent_name_'+index" label="Dependant Name" v-if="showNames">
                    <input autocomplete="off" name="dependent_name" type="text"
                           v-model="theDependant.name"
                           :id="'dependent_name_'+index"
                           v-field-control
                           maxlength="100"
                           v-field-control:dependent_name.required="{type:'text', rules:'name'}"
                           required>
                    <control-error :show="$error('dependent_name')">
                        The dependant's name is required and must be a valid name
                    </control-error>
                </control>
                <control :name="'date_of_birth_'+index" label="Date of Birth">
                    <date-input v-model="theDependant.dateOfBirth"
                                v-field-control:dependant_date_of_birth.required="{type:'date'}"
                                @input="update"></date-input>
                    <control-error :show="$error('dependant_date_of_birth')">
                        The dependant's date of birth is required and must be in the format DD/MM/YYYY
                    </control-error>
                </control>
                <control :name="'dependant_gender'+index" label="Gender">
                    <select name="dependant_gender"
                            @change="update"
                            :id="'dependant_gender'+index"
                            v-model="theDependant.gender"
                            v-field-control
                            required>
                        <option :value="null" disabled hidden>Please select...</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                    </select>
                    <control-error :show="$error('dependant_gender')">
                        The dependant gender is required
                    </control-error>
                </control>
                <life-expectancy label="Dependant's Life Expectancy"
                                 :person="theDependant"
                                 :type="'dependant'"
                                 :index="this.index"
                                 :stepValid="stepValid"
                                 :assumed-settlement="claimDetails('assumedSettlement')"
                                 @update="updateLife">
                </life-expectancy>
            </div>
            <div class="flex-grid__item flex-grid--space-left">
                <control label="Age at Deceased’s Date of Death" before-after="years-old">
                    <input autocomplete="off" type="text" :value="ageAtDeceasedDod" v-two-dp disabled>
                </control>
                <control label="Current Age" before-after="years-old">
                    <input autocomplete="off" type="text" :value="age" v-two-dp disabled>
                </control>
                <control label="Age at Assumed Settlement" before-after="years-old">
                    <input autocomplete="off" type="text" :value="ageAtAssumedSettlement" v-two-dp disabled>
                </control>
                <control label="Age at Deceased's End of Life" before-after="years-old">
                    <input autocomplete="off" type="text" :value="ageAtDeceasedButForDod" v-two-dp disabled>
                </control>
                <control label="End of Dependency" for="end_of_dependency">
                    <div class="a-form-inputs--half">
                        <div class="a-form-inputs__container">
                            <input autocomplete="off"
                                   type="text"
                                   :value="dependency.date"
                                   disabled>
                        </div>
                        <div class="a-form-inputs__container a-form-inputs--years">
                            <input autocomplete="off" type="number" v-model="endOfDependencyDuration"
                                   name="end_of_dependency"
                                   v-field-control
                                   min="0.1"
                                   step="0.01"
                                   required
                                   disabled>
                            <control-error :show="$error('end_of_dependency') || !endOfDependencyValid()">
                                There must be a period of dependency
                            </control-error>
                        </div>
                    </div>
                </control>
            </div>
        </form>
        <div class="flex-grid__g-8">
            <button tabindex="-1" class="a-button u-margin-top-0 u-margin-bottom-0" @click="deleteThisDependant">Delete
                Dependant
            </button>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import DateInput from 'components/form/control/DateInput.vue';
    import FormValidator from 'components/form/validator/mixin';
    import LifeExpectancy from 'components/LifeExpectancy.vue';
    import moment from 'moment';
    import {setStepValid} from 'services/routingMethods';
    import {mapActions, mapGetters} from 'vuex';
    import roundValue from 'mixins/roundValue';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';

    export default {
        name: 'dependant',
        props: ['index', 'stepValid'],
        components: {
            Control,
            ControlError,
            LifeExpectancy,
            DateInput
        },
        mixins: [
            FormValidator,
            roundValue
        ],
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        computed: {
            ...mapGetters('fatal/dependency/claimDetails', {
                'claimDetails': 'value',
            }),
            ...mapGetters('fatal/dependency/dependants', {
                findDependant: 'findDependant',
                durationOfDependency: 'durationOfDependency',
                getPreTrialDependency: 'preTrialDependency'
            }),
            ...mapGetters('fatal/dependency/deceased', ['theDeceased', 'theDeceasedLifeExpectancy']),
            ...mapGetters('user', ['showNames']),
            deceasedDateOfDeath: {
                get() {
                    return this.theDeceasedLifeExpectancy['dateOfDeath'];
                },
            },
            theDependant() {
                let theDependant = {};
                Vue.util.extend(theDependant, this.findDependant(this.index));
                return theDependant;
            },
            dependency() {
                return this.durationOfDependency(this.index);
            },
            endOfDependencyDuration() {
                return this.roundValue(this.dependency.duration, 2);
            },
            age() {
                if (this.theDependant.dateOfBirth) {
                    return moment().diff(moment(this.theDependant.dateOfBirth, 'DD/MM/YYYY'), 'years', true);
                }
            },
            ageAtDeceasedDod() {
                if (this.theDependant.dateOfBirth) {
                    return moment(this.theDeceased.dateOfDeath, 'DD/MM/YYYY')
                        .diff(moment(this.theDependant.dateOfBirth, 'DD/MM/YYYY'), 'years', true);
                }
            },
            ageAtAssumedSettlement() {
                if (this.theDependant.dateOfBirth) {
                    return moment(this.claimDetails('assumedSettlement'), 'DD/MM/YYYY')
                        .diff(moment(this.theDependant.dateOfBirth, 'DD/MM/YYYY'), 'years', true);
                }
            },
            ageAtDeceasedButForDod() {
                if (this.theDependant.dateOfBirth) {
                    return moment(this.deceasedDateOfDeath, 'DD/MM/YYYY')
                        .diff(moment(this.theDependant.dateOfBirth, 'DD/MM/YYYY'), 'years', true);
                }
            },
        },
        methods: {
            ...mapActions('fatal/dependency/dependants', [
                'updateDependant',
                'updateDependantLifeExpectancy',
                'deleteDependant',
                'updateDependantYouth'
            ]),
            ...mapActions('fatal/dependency', ['checkToUpdateMultipliers']),
            deleteThisDependant() {
                this.deleteDependant(this.index);
            },
            update() {
                this.updateDependant({index: this.index, dependant: this.theDependant});
            },
            updateLife(lifeExpectancy) {
                this.updateDependantLifeExpectancy({index: this.index, lifeExpectancy})
                    .then(() => {
                        if (lifeExpectancy.method === 'enter_date'
                            && (lifeExpectancy.dateOfDeathIsAssumed === ""
                                || lifeExpectancy.dateOfDeathIsAssumed === null)) {
                            return;
                        }
                        this.update();
                        this.checkToUpdateMultipliers();
                    });
            },
            endOfDependencyValid() {
                let valid = (
                    this.dependency.duration
                    && this.roundValue(this.dependency.duration, 2) > 0.1
                    && this.dependency.duration !== null
                );

                setStepValid(this.$valid() && valid);

                return valid;
            },
        }
    }
</script>


// WEBPACK FOOTER //
// Dependant.vue?2108bce2